import "./style.css";
import { Routes, Route, Navigate } from "react-router-dom";
import React, { useContext } from "react";
// import { useContext } from "react";
// import { studentDataContext } from "../../../contextAdmin/Admin/StudentData";
// import Header from "../Header";
// import Popup from "../Popup";
// import { popupContext } from "../../../contextAdmin/Admin/Popup";
import Classroom from "../../../pages/Admin/Classrooms/Classroom";
import Students from "../../../pages/Admin/Students/Students";
import StudentDetails from "../../../pages/Admin/StudentDetails/StudentDetails";
// import Students from "../../../pages/Admin/Students";

// import Classrooms from "../../../pages/Admin/Classrooms";
import AdminPermissionUi from "../../../pages/Admin/AdminPermissionUi/AdminPermissionUi";
import { userContext } from "../../../contextAdmin/Admin/User";
// import StudentDetails from "../../../pages/Admin/StudentDetails";
// import Login from "../../../pages/Admin/Login";
// import Students from "../../../pages/Admin/Students";

// Creator : Team E - chanan
function MainAdmin() {
  const { user } = useContext(userContext)

  if (user.permissions === "teacher") {
    return (
      < Routes >
        <Route path="/classrooms" element={<Classroom />} />
        <Route path="/students/:class_id" element={<Students />} />
        <Route path="/studentDetails" element={<StudentDetails />} />
        <Route path="*" element={<Navigate to={"/classrooms"} />} />
        {/* <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<AdminPermissionUi />} />
        <Route path="/studentDetails" element={<StudentDetails />} /> */}
        {/* <Route path="/test" element={<Test />} />
                <Route path="/layout" element={<AdminLayout/>} /> */}
        {/* <Route path="/login" element={< />} /> 
                  <Route path="/home" element={< />} />
             <Route path="/singUp" element={< />} />  */}
      </Routes >)
  } else if ((user.permissions === "admin")) {
    return (
      < Routes >
        <Route path="/teachers" element={<AdminPermissionUi />} />
        <Route path="/classrooms" element={<Classroom />} />
        <Route path="/students/:class_id" element={<Students />} />
        <Route path="/studentDetails" element={<StudentDetails />} />
        <Route path="*" element={<Navigate to={"/teachers"} />} />

        {/* <Route path="*" element={<Navigate to={"/teachers"} />} /> */}
        {/* <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/admin" element={<AdminPermissionUi />} />
    <Route path="/studentDetails" element={<StudentDetails />} /> */}
        {/* <Route path="/test" element={<Test />} />
  <Route path="/layout" element={<AdminLayout/>} /> */}
        {/* <Route path="/login" element={< />} /> 
  <Route path="/home" element={< />} />
<Route path="/singUp" element={< />} />  */}
      </Routes >)


  }
}

export default MainAdmin;
